import '../assets/css/socialmedia.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDatabase, faCode, faServer, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faGithub, faHackerrank, faFacebookF, faYoutube, faTwitter, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const SocialMedia = () => {

    const socialMedia1 = {
        '--clr': 'var(--linkedin_bg)',
    }
    const socialMedia2 = {
        '--clr': 'var(--github_bg)',
    }
    const socialMedia3 = {
        '--clr': 'var(--hackerrank_bg)',
    }
    const socialMedia4 = {
        '--clr': 'var(--mail_bg)',
    }

    const emailId = "indianmohibkhan@gmail.com";
    const subject = "";
    const body = "";
    const mailHref = `mailto:${emailId}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    return (
        <div className="socialmedia_container">
            {/* <span style={bubble20}><FontAwesomeIcon className="icon-center" icon={faReact} /></span> */}

            <ul>
                <li className="social-media-4">
                    <a style={socialMedia4} href={mailHref} target="_blank"><FontAwesomeIcon className="icon-center" icon={faEnvelope} /></a>
                </li>
                <li className="social-media-1">
                    <a style={socialMedia1} href="https://www.linkedin.com/in/MdMohibKhan" target="_blank"><FontAwesomeIcon className="icon-center" icon={faLinkedinIn} /></a>
                </li>
                <li className="social-media-2">
                    <a style={socialMedia2} href="https://github.com/MdMohibKhan" target="_blank"><FontAwesomeIcon className="icon-center" icon={faGithub} /></a>
                </li>
                <li className="social-media-3">
                    <a style={socialMedia3} href="https://www.hackerrank.com/profile/MDMOHIBKHAN" target="_blank"><FontAwesomeIcon className="icon-center" icon={faHackerrank} /></a>
                </li>


            </ul>

        </div>
    );
}

export default SocialMedia;
